import styled from 'styled-components'

export const Message = styled.p`
  color: #e4f2e7;
`
